
export default function Hero() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e196d54d854868260ec6eef258507111.jpg"
          alt="유앤아이월드 나눔 활동"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto w-full">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight tracking-tight">
          유앤아이월드와 함께하는<br />
          나눔의 발걸음이<br />
          내일의 행복을 만듭니다
        </h1>
        <p className="text-xl md:text-2xl text-white/90 mb-10 font-light">
          작은 나눔이 모여 큰 변화를 만듭니다
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="https://www.ihappynanum.com/Nanum/B/T3T4SOHMUI"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-blue-600 hover:bg-blue-700 text-white px-10 py-4 rounded-lg text-lg font-semibold transition-all duration-300 hover:transform hover:-translate-y-1 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            후원하기
          </a>
          <a
            href="#about"
            className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white px-10 py-4 rounded-lg text-lg font-semibold transition-all duration-300 border-2 border-white/50 whitespace-nowrap cursor-pointer"
          >
            자세히 알아보기
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/70 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}
